import { Injectable } from '@angular/core';
import { BaseHttpClientService } from '../../base-http-client.service';
import { GetUserBoughtExamsModel } from 'src/app/shared/api-models/responses/exam/GetUserBoughtExamsModel';
import { GetUserNotBoughtExamsModel } from 'src/app/shared/api-models/responses/exam/GetUserNotBoughtExamsModel';

/**
 * گرفتن لیست مقاطع تحصیلی
 */
@Injectable({
  providedIn: 'root'
})
export class GetUserNotBoughtExamsService {
  constructor(private baseClient: BaseHttpClientService) { }

  call(grade_id, exam_type, book_id) {
    const params = book_id ? { book_id } : null;
    const res = this.baseClient.getWithAuth<GetUserNotBoughtExamsModel[]>(
      `/api/v1/exam/get_user_not_bought_exams/${grade_id}/${exam_type}`, params
    );

    return res;
  }
}
